module.exports = __webpack_public_path__ + "img/brp-disabled.6eb1ed38.svg";